import React from 'react';
import { NextTaskInfo } from '@/lib/business-ideas';
import { getStageColor } from '@orbit/shared/constants';

interface TaskCardProps {
  task: NextTaskInfo;
}

const TaskCard: React.FC<TaskCardProps> = ({ task }) => {
  return (
    <div className="group bg-background-surface/95 backdrop-blur-sm rounded-lg border border-gray-600 p-4 pb-6 hover:border-blue-500 hover:shadow-lg hover:scale-[1.02] transition-all duration-200 cursor-pointer relative overflow-hidden h-36">
      {/* Right arrow indicator */}
      <div className="absolute top-3 right-3 text-blue-400 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 18L15 12L9 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Subtle outline on hover */}
      <div className="absolute inset-0 rounded-lg border-2 border-transparent group-hover:border-blue-500/20 transition-colors duration-200 pointer-events-none"></div>

      <div className="flex items-center gap-2 mb-3">
        <span className={`text-xs text-white px-2 py-1 rounded ${getStageColor(task.stage)}`}>
          {task.stage}
        </span>
        <span className="text-xs text-text-secondary bg-gray-700 px-2 py-1 rounded">
          {task.module}
        </span>
        {task.premium && (
          <span className="text-xs text-yellow-400 bg-yellow-900/20 px-2 py-1 rounded border border-yellow-500">
            Premium
          </span>
        )}
      </div>

      <h3 className="text-lg font-medium text-white mb-2 line-clamp-2 group-hover:text-blue-300 transition-colors duration-200">
        {task.title}
      </h3>

      <p className="text-text-secondary text-sm line-clamp-2 group-hover:text-text-primary transition-colors duration-200">
        {task.description}
      </p>
    </div>
  );
};

export default TaskCard;
